
import moment from "moment";
import {
  dashboardGetters,
  usersGetters,
  dashboardActions,
} from "~/store/helpers";

export default {
  props: {
    board_id: [Number, String],
    editing: Boolean,
    card: Object,

    title: String,
    contenteditable: Boolean,
    id: [Number, String],
  },
  data() {
    return {
      loading: true,
      organizationId: null,
      mId: this.$props.id,
      currentPage: 1,
      perPage: 15,
      fields: [],
      items: [],
    };
  },
  async mounted() {
    this.organizationId = localStorage.getItem("organizationId");
    this.$store
      .dispatch(`modules/users/getPatientTableColumns`, {
        organizationId: this.organizationId,
      })
      .then((res) => {
        this.fields =
          res.data.columns.length <= 10
            ? res.data.columns
            : [
                "alerts",
                "display_name",
                "age",
                "plan_name",
                "blood_pressure",
                "glucose",
                "oxygen_saturation",
                "weight",
                "heart_rate",
              ];
      });
    this.items = await this.getQuery({
      organizationId: this.organizationId,
      query: this.card.query_name,
    });
    this.perPage = this.items.pagination?.item_per_page;
    this.currentPage = this.items.pagination?.current_page;
    this.loading = false;
  },
  computed: {
    ...dashboardGetters,
    ...usersGetters,
    mItems() {
      return this.items.data ?? [];
    },
    rows() {
      return this.items.pagination?.total;
    },
    getUserTableHeaders() {
      return this.fields.map((element) => {
        return {
          key: element,
          label: this.$i18n.t(`columns.${element}`),
          Sortable:
            element === "age" ||
            element === "created_at" ||
            element === "last_active"
              ? true
              : false,
        };
      });
      return state.columns.length > 10
        ? initialArray.sort((a, b) => a.id - b.id).map((e) => e.name)
        : state.columns;
    },
  },
  methods: {
    ...dashboardActions,

    getTitle(event) {
      this.$emit("tableTitle", event.target.innerText);
    },
    localizeDate(string) {
      return moment
        .utc(string)
        .local()
        .locale(this.$i18n.locale)
        .format("L") !== "Invalid date"
        ? moment.utc(string).local().locale(this.$i18n.locale).format("L")
        : "-";
    },
    localizeGlucoseMeal(string) {
      if (string === "-") {
        return string;
      }
      return this.$t(`meals.${string}`);
    },
    clickPatient(event) {
      this.$router.push({
        name: `users-id-overview`,
        params: { id: event.id },
      });
    },
    getGlucoseTime(string) {
      return moment(string).locale(this.$i18n.locale).format("LL") !==
        "Invalid date"
        ? moment(string).locale(this.$i18n.locale).format("L") +
            " " +
            moment(string).locale(this.$i18n.locale).format("LT")
        : "-";
    },
    localizeCCMRPM(string, type) {
      let localizedString = string.split("");
      return (
        localizedString[0] +
        " " +
        this.$t(`time_of_day.${localizedString.at(-1)}`)
      );
    },
  },
};
